import { CmsImage, CmsLink, CmsRichText, globals } from 'common-ui';
import type { ProductCardProps } from './ProductCard';
import ProductCardPrice from './ProductCardPrice';
import { productLinkBuilder } from 'common-next/src/components/common-functions';

const ProductInfoMultiView = (props: ProductCardProps) => {
  const { productPrice, productPriceOriginal, productVintage, productNumberOfBottles, productMemberPrice } =
    props || {};

  const { productImageSecondary } = props || {};

  const {
    productCardTitle,
    productCardTitleUrl,
    productCardSubTitle,
    productCardDescription,
    productDescription,
    productLink,
    multiViewPrices,
    multiViewPriceDiff,
    hidePriceOnMultiView,
    productCode,
    handleCmlpDLEvent,
  } = props || {};

  const getNameUrl = () => {
    let nameUrl = '#';
    if (productCardTitleUrl) {
      nameUrl = productCardTitleUrl;
    } else if (globals.brandId !== 'amx') {
      nameUrl = productLinkBuilder(productCardTitle, productVintage, productCode);
    }
    return nameUrl;
  };

  const renderProductTitle = () => {
    const nameUrl = getNameUrl();
    return (
      productCardTitle && (
        <div className="product-name-box">
          <a
            href={nameUrl}
            className="product-name h2"
            onClick={() => {
              handleCmlpDLEvent?.('headline', undefined, nameUrl);
            }}
          >
            {productCardTitle}
          </a>
        </div>
      )
    );
  };

  const renderSubtitle = () =>
    productCardSubTitle && <div className="product-card__subtitle h6">{productCardSubTitle}</div>;

  const renderDescription = () => {
    if (productCardDescription) {
      return (
        <div className="product-card__desc">
          <CmsRichText contentItem={productCardDescription} />
        </div>
      );
    }

    if (productDescription) {
      return (
        <div className="product-card__desc">
          <div dangerouslySetInnerHTML={{ __html: productDescription }} />
        </div>
      );
    }

    return null;
  };

  const renderSecondaryImage = () =>
    productImageSecondary && (
      <div className="product-card__img-secondary">
        <CmsImage contentItem={productImageSecondary} />
      </div>
    );

  const renderBottomPrice = () =>
    !multiViewPriceDiff &&
    !hidePriceOnMultiView && (
      <ProductCardPrice
        productPrice={productPrice}
        productPriceOriginal={productPriceOriginal}
        productNumberOfBottles={productNumberOfBottles}
        productMemberPrice={productMemberPrice}
        productName={productCardTitle ?? ''}
        productCode={productCode}
        multiViewPriceDiff={multiViewPriceDiff}
      />
    );

  const renderProductLinks = () =>
    productLink && (
      <div className="product-card-button">
        {productLink.map((value: any, index: number) => {
          const hasMultiViewPrice =
            multiViewPriceDiff && multiViewPrices && multiViewPrices.length > 0 && !hidePriceOnMultiView;

          return (
            <div key={`productCardButton-${index + 1}`}>
              {hasMultiViewPrice && (
                <ProductCardPrice
                  productPrice={multiViewPrices[index]?.productPrice}
                  productPriceOriginal={multiViewPrices[index]?.productPriceOriginal}
                  productNumberOfBottles={multiViewPrices[index]?.productNumberOfBottles}
                  productMemberPrice={multiViewPrices[index]?.productMemberPrice}
                  productName={productCardTitle ?? ''}
                  productCode={productCode}
                  multiViewPriceDiff={multiViewPriceDiff}
                />
              )}
              <CmsLink key={`cmsLink-${index + 2}`} contentItem={value} hit={props.product} />
            </div>
          );
        })}
      </div>
    );

  return (
    <div className="product-card__info product-card__info--multiview">
      <div className="product-card__info-top">
        {renderProductTitle()}
        {renderSubtitle()}
        {renderDescription()}
        {renderSecondaryImage()}
      </div>
      <div className="product-card__info-bottom">
        {renderBottomPrice()}
        {renderProductLinks()}
      </div>
    </div>
  );
};

export default ProductInfoMultiView;
